import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import BackButton from 'components/common/BackButton';
import './style.scss';

const MainWithBackButton = ({ className, children, isLarge = false, title = null, to }) => {
    const history = useHistory();
    const { t } = useTranslation();

    return (
        <main className="main-with-back-button__wrapper">
            <div className="main-with-back-button__button-container">
                <BackButton
                    handleClick={to ? () => history.push(to) : () => history.goBack()}
                    text={t('common.back')}
                />
            </div>
            <div className={classnames('main', { 'main--large': isLarge }, className)}>
                {title ? <h1 className="title main-with-back-button__title">{title}</h1> : null}
                {children}
            </div>
        </main>
    );
};

MainWithBackButton.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    isLarge: PropTypes.bool,
    title: PropTypes.string,
    to: PropTypes.string,
};

export default MainWithBackButton;
